import {
  Col,
  Row,
  Form,
  Select,
  Input,
  DatePicker,
  message,
  Switch,
} from "antd";
import { useTranslation } from "react-i18next";
import { Option } from "./AddEditCustomer";
import InputName from "../UI/InputNumberComponent/InputName";
import { Dispatch } from "react";

type props = {
  formatedContactType: Option[] | undefined;
  loadingContactType: boolean;
  setFullName: any;
  setIsFullNameValid: any;
  setFullNameErrorMessage: any;
  setSelectedContactType: Dispatch<any>;
  rest?: any;
  maxLength?: number;
  customer: any;
  isEdit: () => boolean;
};
function GeneralInformation({
  setFullName,
  setIsFullNameValid,
  setFullNameErrorMessage,
  formatedContactType,
  setSelectedContactType,
  rest,
  maxLength = 49,
  customer,
  isEdit,
}: props) {
  const [t] = useTranslation("common");

  const handleFullNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const fullName = event.target.value;

    setFullName(fullName);

    // Allowing letters, numbers, and spaces in the full name
    const pattern = /^[A-Za-z0-9\u0600-\u06FF\s]+$/u.test(fullName);

    setIsFullNameValid(pattern);
    setFullNameErrorMessage(pattern ? "" : "Full name can only contain letters, numbers, and spaces");

    if (fullName.length <= maxLength) {
      if (rest && rest.onChange && typeof rest.onChange === "function") {
        rest.onChange(fullName);
      }
    } else {
      message.warning("Maximum length reached!");
    }
  };

  return (
    <>
      <Row gutter={12}>
        <Col md={6}>
          {isEdit() ? (
            <Form.Item
              label={`${t("status")}`}
              name="isActive"
              valuePropName={customer?.isActive ? "checked" : ""}
              initialValue={customer?.isActive}
            >
              <Switch
                data-testid="status-toggle"
                checkedChildren={`${t("active")}`}
                unCheckedChildren={`${t("inactive")}`}
              />
            </Form.Item>
          ) : (
            <Form.Item
              label={`${t("status")}`}
              name="isActive"
              valuePropName="checked"
            >
              <Switch
                checkedChildren={`${t("active")}`}
                unCheckedChildren={`${t("inactive")}`}
                defaultChecked
                disabled
              />
            </Form.Item>
          )}
          <Form.Item
            name="typeId"
            label={`${t("contact-type")}`}
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Select
              showSearch={true}
              optionFilterProp="label"
              placeholder={`${t("select-contact-type")}`}
              options={formatedContactType}
              data-testid="contact-Type"
              onChange={(value: any) => setSelectedContactType(value)}
            />
          </Form.Item>

          <Form.Item
            name="name"
            label={`${t("fullname")}`}
            rules={[
              {
                required: true,
                message: "full name is required",
              },
            ]}
          >
            <Input
              maxLength={50}
              autoComplete="off"
              placeholder={`${t("enter-text")}`}
              onChange={handleFullNameChange}
              data-testid="fullname-input"
            />
          </Form.Item>

          <Form.Item name="abbreviation" label={`${t("abbreviation")}`}>
            <InputName maxLength={20} data-testid="abbreviation-input" />
          </Form.Item>

          <Form.Item name="dob" label={`${t("date-of-birth")}`}>
            <DatePicker
              placeholder={`${t("DD/MM/YYYY")}`}
              format="DD/MM/YYYY"
              style={{ width: "100%" }}
            />
          </Form.Item>
        </Col>
        <Col md={6}>
          <Form.Item
            label={`${t("status")}`}
            name="isActive"
            valuePropName="checked"
            style={{ visibility: "hidden" }}
          >
            <Switch
              checkedChildren={`${t("active")}`}
              unCheckedChildren={`${t("inactive")}`}
            />
          </Form.Item>
          <Form.Item
            name="notes"
            label={`${t("notes")}`}
            style={{ marginLeft: "1rem" }}
          >
            <Input.TextArea
              maxLength={1000}
              autoComplete="off"
              placeholder={`${t("enter-text")}`}
              autoSize={{ minRows: 4, maxRows: 6 }}
            />
          </Form.Item>
        </Col>
      </Row>
    </>
  );
}

export default GeneralInformation;
